import { format, formatDistance, parse } from "date-fns";
import deLocale from "date-fns/locale/de";

import { datePickerDisplayFormat, isoDateFormat } from "./formats";

const localeStringConfig: Intl.NumberFormatOptions = {
  currency: "EUR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
};

export const formatCurrency = (value: number) =>
  value.toLocaleString("de-DE", {
    ...localeStringConfig,
    style: "currency"
  });

export const formatDecimalCurrency = (value: number) =>
  value.toLocaleString("de-DE", {
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: "currency"
  });

export const formatWithThousandsSeparator = (value: number) =>
  value.toLocaleString("de-DE", localeStringConfig);

export const formatPercent = (value: number) => `${value} %`;
export const formatArea = (value: number): JSX.Element => (
  <span>
    {formatWithThousandsSeparator(value)}
    {" m"}
    <sup>2</sup>
  </span>
);
export const formatDistanceInKm = (value: number) => `${formatWithThousandsSeparator(value)} km`;

export const formatYears = (value: number) => (value === 1 ? `${value} Jahr` : `${value} Jahre`);
export const formatMonths = (value: number) => (value === 1 ? `${value} Monat` : `${value} Monate`);
export const formatThousandsCurrency = (value: number) =>
  `${formatWithThousandsSeparator(value)} T€`;

export const timeDistanceFromDate = (pastDate: Date) =>
  formatDistance(pastDate, new Date(), { locale: deLocale });

export const timeDistanceFromISO = (date: string) =>
  formatDistance(parse(date, isoDateFormat, new Date()), new Date(), {
    locale: deLocale
  });
export const formatDateFromISO = (date: string): string =>
  format(parse(date, isoDateFormat, new Date()), datePickerDisplayFormat);

interface Agent {
  firstName: string;
  lastName: string;
  id: string;
}

export const getAgentsOptions = (agents: Agent[]): { label: string; value: string }[] =>
  agents.map(agent => ({
    label: `${agent.firstName} ${agent.lastName}`,
    value: agent.id
  }));
